export default __webpack_public_path__ + "static/media/twitter-icon.c55dd1f4.png";